import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-url',
  templateUrl: './support-url.component.html',
  styleUrls: ['./support-url.component.scss']
})
export class SupportUrlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
